import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { G, errMsg } from "./guestApi";

const F = [["name", "Guest name"], ["phone", "Phone"], ["email", "Email"], ["city", "City"],
  ["birthday", "Birthday"], ["anniversary", "Anniversary"], ["notes", "Notes"], ["consent", "Consent (file value)"]];

export function RowEditor({ row, session, batchId, onClose, onSaved }) {
  const [raw, setRaw] = useState({ ...row.raw });
  const [confirmE164, setConfirmE164] = useState(row.phone?.suggestion || "");
  const save = async (extra = {}) => {
    try {
      const r = await api.post(`${G}/import/row-update`, { token: session.token, batch_id: batchId,
        row_id: row.id, raw, ...extra });
      onSaved(r.data); onClose();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="guest-row-editor">
        <DialogHeader>
          <DialogTitle>Correct row {row.ref.row_no} · {row.ref.table_id}</DialogTitle>
          <DialogDescription>{(row.issues || []).join("; ") || "Edit values from the file."}</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          {F.map(([k, l]) => (
            <div key={k} className={k === "notes" || k === "name" ? "col-span-2" : ""}>
              <Label className="text-xs">{l}</Label>
              <Input className="h-8" value={raw[k] || ""} onChange={(e) => setRaw({ ...raw, [k]: e.target.value })}
                data-testid={`guest-row-edit-${k}`} />
            </div>))}
        </div>
        {row.status === "NEEDS_CONFIRMATION" && (
          <div className="rounded border border-orange-300 bg-orange-50 p-2 space-y-1">
            <Label className="text-xs">Confirm the full international number</Label>
            <div className="flex gap-2">
              <Input className="h-8" value={confirmE164} onChange={(e) => setConfirmE164(e.target.value)}
                data-testid="guest-row-confirm-phone" />
              <Button size="sm" onClick={() => save({ confirm_phone_e164: confirmE164 })}
                disabled={!confirmE164.startsWith("+")} data-testid="guest-row-confirm-btn">Confirm</Button>
            </div>
            {(row.phone?.alternatives || []).map((a) => (
              <Button key={a} size="sm" variant="outline" onClick={() => setConfirmE164(a)}>Use {a}</Button>))}
          </div>)}
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => save({ resolution: "SKIP" })} data-testid="guest-row-skip">Skip row</Button>
          <Button onClick={() => save()} data-testid="guest-row-save">Save &amp; re-check</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
